const navToggle = document.querySelector('.nav-main-toggle');
const navMain   = document.querySelector('.nav-main');
const mainContent = document.querySelector('main');

if (navToggle && navMain) {
    navToggle.addEventListener('click', () => {
        navMain.classList.toggle('nav-open');
        navToggle.classList.toggle('nav-open');
        mainContent.classList.toggle('nav-open');
    });
}

// Fill the nav track with enough copies to cover the container width
function fillNavTrack() {
    const track = document.querySelector('.nav-main__track');
    if (!track) return;

    // Remove all clones, keep only the original
    track.querySelectorAll('.nav-main__menu[aria-hidden]').forEach(el => el.remove());

    const original = track.querySelector('.nav-main__menu');
    if (!original) return;

    const trackWidth  = track.parentElement.offsetWidth;
    const itemWidth   = original.offsetWidth;
    if (!itemWidth) return;

    const copies = Math.ceil(trackWidth / itemWidth);

    for (let i = 0; i < copies; i++) {
        const clone = original.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a').forEach(a => a.setAttribute('tabindex', '-1'));
        track.appendChild(clone);
    }
}

document.addEventListener('DOMContentLoaded', fillNavTrack);
window.addEventListener('resize', fillNavTrack);